import { Injectable, signal } from '@angular/core'
import { HttpService } from '@bases/http.service'
import { API_URL, APP_NAME } from '@core/constants/constant.data'

export interface Notification {
  id: string
  type: string
  title: string
  body: string
}

@Injectable({
  providedIn: 'root',
})
export class NotificationsService extends HttpService {
  protected _baseUrl = API_URL + '/utils'
  notifications$ = signal<Notification[]>([])

  constructor() {
    super()
  }

  notificationParsers: Record<string, (payload: any) => Partial<Notification>> = {
    maintenance: (payload) => ({
      body: (payload.body || '')
        .replace('{startDate}', new Date(payload.startDate).toLocaleString())
        .replace('{endDate}', new Date(payload.endDate).toLocaleString())
        .replace('{appName}', APP_NAME),
    }),

    release: (payload) => ({
      body: (payload.body || '')
        .replace('{version}', payload.version)
        .replace('{appName}', APP_NAME),
    }),
  }

  async getNotifications() {
    const results = await this.GET(`${this._baseUrl}/notifications/${APP_NAME}`)
    let notificationList: Notification[] = []

    if (results?.notifications?.length > 0) {
      for (const notif of results.notifications) {
        const id = notif.id || ''
        const type = notif.payload.notificationType || ''
        const payload = notif.payload || {}
        const title = payload.title || ''

        const payloadParser = this.notificationParsers[type]
        const payloadParsed = payloadParser
          ? payloadParser(payload)
          : { body: payload.body ?? '', data: payload }

        notificationList.push({
          id,
          type,
          title,
          body: payloadParsed.body,
        })
      }
    }

    let readIds: string[] = JSON.parse(localStorage.getItem('notificationNoticeRead') || '[]')
    readIds = readIds.filter((id) => notificationList.some((notif) => notif.id === id))
    localStorage.setItem('notificationNoticeRead', JSON.stringify(readIds))

    notificationList = notificationList.filter((notif) => !readIds.includes(notif.id))
    this.notifications$.set(notificationList)
  }
}
